import {
  AUTO_ALLOCATE_REQUEST,
  AUTO_ALLOCATE_SUCCESS,
  AUTO_ALLOCATE_FAILURE,
  AUTO_UNALLOCATE_REQUEST,
  AUTO_UNALLOCATE_SUCCESS,
  AUTO_UNALLOCATE_FAILURE,
  GET_AUTO_ALLOCATION_DETAILS_SUCCESS,
  GET_AUTO_ALLOCATION_DETAILS_FAILURE,
  GET_AUTO_ALLOCATION_DETAILS_REQUEST,
  AUTO_ALLOCATE_UPDATE_DATES,
  AUTO_ALLOCATE_LOG,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';
import { autoAllocateDate, autoAllocateOrgUnitId } from '../../../reducers/areas/dailyPlanning/selectors';
import globals from '../../../globals/communityGlobals';

const overrideApiUrl = globals.urls.autoAllocateApiUrl;

export function setAutoAllocateDateAndTeam(data) {
  return {
    type: AUTO_ALLOCATE_UPDATE_DATES,
    data,
  };
}

export function autoAllocate(queryData) {
  return {
    types: [AUTO_ALLOCATE_REQUEST, AUTO_ALLOCATE_SUCCESS, AUTO_ALLOCATE_FAILURE],
    orgUnitId: queryData.orgUnitId || 0,
    date: queryData.date || null,
    buildCallParameters: () => ({
      method: HTTP_METHOD.POST,
      path: 'v1/command/AutoAllocate',
      data: queryData,
      overrideApiUrl,
    }),
  };
}

export function resetRunningAutoAllocate(queryData) {
  return {
    type: AUTO_ALLOCATE_SUCCESS,
    orgUnitId: queryData.orgUnitId || 0,
    date: queryData.date || null,
  };
}

export function getAutoAllocationDetails() {
  return {
    types: [
      GET_AUTO_ALLOCATION_DETAILS_REQUEST,
      GET_AUTO_ALLOCATION_DETAILS_SUCCESS,
      GET_AUTO_ALLOCATION_DETAILS_FAILURE,
    ],
    buildCallParameters: state => ({
      method: HTTP_METHOD.GET,
      path: 'v1/query/GetAutoAllocationDetails',
      selectedDate: autoAllocateDate(state),
      orgUnitId: autoAllocateOrgUnitId(state),
      overrideApiUrl,
    }),
  };
}

export function autoUnallocate(queryData) {
  return {
    types: [AUTO_UNALLOCATE_REQUEST, AUTO_UNALLOCATE_SUCCESS, AUTO_UNALLOCATE_FAILURE],
    orgUnitId: queryData.orgUnitId || 0,
    date: queryData.date || null,
    buildCallParameters: () => ({
      method: HTTP_METHOD.POST,
      path: 'v1/command/AutoUnallocate',
      data: queryData,
      overrideApiUrl,
    }),
  };
}

export function setAutoAllocationLogSetting(createLog) {
  return {
    type: AUTO_ALLOCATE_LOG,
    createLog,
  };
}
